import { EffectHandler } from "../types/editor"
import $ from "jquery"
import { toast } from "@/utils/util"
import { isSpecialString } from "@/utils/validate"

const MultiToneHanlder: EffectHandler = {
    multiToneCache: {}, // 多音字缓存，避免重复请求
    // 获取多音字列表
    getMultiToneOption(editor, wordText) {
        if (this.multiToneCache[wordText]) {
            return Promise.resolve(this.multiToneCache[wordText])
        }
        return editor.$http("getWordPinyinByText", {
            language: "zh-cn",
            word: wordText,
        }).then((res: any) => {
            if (res.err_code == 0) {
                let mutilTone = (res.data || [])
                    .concat(res.pron || [])
                    .concat(res.tone || [])
                if (mutilTone.length > 0) {
                    const multiToneOptions = [... new Set(mutilTone)].map((item: any) => {
                        return { name: item, value: item }
                    })
                    this.multiToneCache[wordText] = multiToneOptions
                    return this.multiToneCache[wordText]
                }
            }
        })
    },
    // 获取当前选中文字
    getSelectedWord(selection) {
        let wordText = "";
        if (selection.el) {
            // 点击选中
            wordText = selection.elText;
        } else if (selection.range && selection.rangeText && selection.rangeText.length === 1) {
            // 滑动选中
            wordText = selection.rangeText;
        } else {
            // 光标前
            wordText = selection.wordTextBeforeCaret;
        }
        return wordText.trim() // 排除空格
    },


    // 面板打开前，返回false阻止面板打开
    beforeSheetOpen(editor, selection ,text="") {
        // 获取当前选中文字
        const wordText = text || this.getSelectedWord(selection)

        if (!wordText || wordText.length !== 1) {
            toast('多音字需要对单个文字进行设置', 'top')
            return false
        }

        if (isSpecialString(wordText)) {
            toast('存在特殊字符，请重新选择', 'top')
            return false
        }

        // 获取拼音列表
        editor.multiToneOptions = []
        this.getMultiToneOption(editor, wordText).then((data) => {
            editor.multiToneOptions = data
        })

        return true
    },

    // 添加
    addEffect(editor, selection, value) {
        let range = selection.wordRangeBeforeCaret // focus时，给光标前面的字配拼音
        if (selection.range && selection.rangeText && selection.rangeText.length === 1) {
            // 滑动选中
            range = selection.range
        }
        editor.addEffectHtml({
            range,
            effectType: 'multi-tone',
            effectValue: value,
            effectRender: () => { }
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default MultiToneHanlder